import React, { FC, FormEvent, useState } from 'react'

import {
  AuthButton,
  AuthButtonColor,
  AuthButtonVariant,
  AuthInput
} from 'modules/auth/components'
import { useTranslation } from 'react-i18next'
import { usePasswordRecoveryMutation } from 'shared/api/auth/requests'
import z from 'zod'

import styles from './RequestEmailForm.module.scss'

interface RequestEmailFormProps {
  onSuccess?: () => void
}

export const RequestEmailForm: FC<RequestEmailFormProps> = ({ onSuccess }) => {
  const { t } = useTranslation('auth', {
    keyPrefix: 'forgot_password.request_email_form'
  })
  const [email, setEmail] = useState('')
  const passwordRecoveryMutation = usePasswordRecoveryMutation({
    onSuccess
  })

  const canSubmit = !!email && z.safeParse(z.email(), email).success

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    e.stopPropagation()
    passwordRecoveryMutation.mutate({
      email,
      application: 'innos'
    })
  }

  return (
    <form className={styles.requestEmailForm} onSubmit={handleSubmit}>
      <AuthInput
        placeholder={t('email_placeholder')}
        type='email'
        name='email'
        value={email}
        onChange={e => setEmail(e.target.value)}
      />
      <AuthButton
        label={t('submit_button')}
        variant={AuthButtonVariant.FILLED_BLUE}
        colorType={AuthButtonColor.GHOST_DARKER}
        fullWidth={true}
        isBold
        disabled={!canSubmit}
        isLoading={passwordRecoveryMutation.isPending}
        type='submit'
      />
    </form>
  )
}
